/**
 * Harvest Mate - OEM Connection API
 *
 * Contact: servicedesk@clevvi.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { LinkMachineRequest } from '../model/link-machine-request';
// @ts-ignore
import { OemMachine } from '../model/oem-machine';
// @ts-ignore
import { Provider } from '../model/provider';
// @ts-ignore
import { UnlinkMachineResponse } from '../model/unlink-machine-response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class OemMachinesService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Link an OEM machine to a Harvester.
     * Links the specified OEM machine to a &#x60;Harvester&#x60; record owned by the contractor. Sets &#x60;harvesters.oem_provider&#x60; and &#x60;harvesters.oem_external_id&#x60;. The partial unique index on &#x60;(oem_provider, oem_external_id)&#x60; prevents two harvesters from linking to the same OEM machine. 
     * @endpoint post /oem-connection/{provider}/machines/{oem_machine_id}/link
     * @param provider OEM provider key.
     * @param oemMachineId OEM-issued machine identifier.
     * @param linkMachineRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public linkOemMachine(provider: Provider, oemMachineId: string, linkMachineRequest: LinkMachineRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any>;
    public linkOemMachine(provider: Provider, oemMachineId: string, linkMachineRequest: LinkMachineRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<any>>;
    public linkOemMachine(provider: Provider, oemMachineId: string, linkMachineRequest: LinkMachineRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<any>>;
    public linkOemMachine(provider: Provider, oemMachineId: string, linkMachineRequest: LinkMachineRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (provider === null || provider === undefined) {
            throw new Error('Required parameter provider was null or undefined when calling linkOemMachine.');
        }
        if (oemMachineId === null || oemMachineId === undefined) {
            throw new Error('Required parameter oemMachineId was null or undefined when calling linkOemMachine.');
        }
        if (linkMachineRequest === null || linkMachineRequest === undefined) {
            throw new Error('Required parameter linkMachineRequest was null or undefined when calling linkOemMachine.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cognito) required
        localVarHeaders = this.configuration.addCredentialToHeaders('cognito', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/oem-connection/${this.configuration.encodeParam({name: "provider", value: provider, in: "path", style: "simple", explode: false, dataType: "Provider", dataFormat: undefined})}/machines/${this.configuration.encodeParam({name: "oemMachineId", value: oemMachineId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/link`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: linkMachineRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List OEM machines available to the contractor.
     * Returns the contractor\&#39;s machines as reported by the OEM. Deere requires at least one organisation in &#x60;granted&#x60; state - otherwise a 409 is returned and the FE should direct the contractor to the per-organisation grants panel. 
     * @endpoint get /oem-connection/{provider}/machines
     * @param provider OEM provider key.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listOemMachines(provider: Provider, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<OemMachine>>;
    public listOemMachines(provider: Provider, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<OemMachine>>>;
    public listOemMachines(provider: Provider, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<OemMachine>>>;
    public listOemMachines(provider: Provider, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (provider === null || provider === undefined) {
            throw new Error('Required parameter provider was null or undefined when calling listOemMachines.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cognito) required
        localVarHeaders = this.configuration.addCredentialToHeaders('cognito', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/oem-connection/${this.configuration.encodeParam({name: "provider", value: provider, in: "path", style: "simple", explode: false, dataType: "Provider", dataFormat: undefined})}/machines`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<OemMachine>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Unlink an OEM machine from its Harvester (SRA003-440).
     * The symmetric inverse of the link. Clears &#x60;harvesters.oem_provider&#x60; and &#x60;harvesters.oem_external_id&#x60; (sets both NULL) on the caller\&#39;s harvester that currently carries the &#x60;(provider, oem_machine_id)&#x60; linkage. This frees the OEM machine from the &#x60;(oem_provider, oem_external_id)&#x60; partial unique index so it can be re-linked to a different harvester. Scoped to a harvester the caller owns; no matching linkage → 404 &#x60;link_not_found&#x60;. 
     * @endpoint delete /oem-connection/{provider}/machines/{oem_machine_id}/link
     * @param provider OEM provider key.
     * @param oemMachineId OEM-issued machine identifier.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public unlinkOemMachine(provider: Provider, oemMachineId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<UnlinkMachineResponse>;
    public unlinkOemMachine(provider: Provider, oemMachineId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<UnlinkMachineResponse>>;
    public unlinkOemMachine(provider: Provider, oemMachineId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<UnlinkMachineResponse>>;
    public unlinkOemMachine(provider: Provider, oemMachineId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (provider === null || provider === undefined) {
            throw new Error('Required parameter provider was null or undefined when calling unlinkOemMachine.');
        }
        if (oemMachineId === null || oemMachineId === undefined) {
            throw new Error('Required parameter oemMachineId was null or undefined when calling unlinkOemMachine.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cognito) required
        localVarHeaders = this.configuration.addCredentialToHeaders('cognito', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/oem-connection/${this.configuration.encodeParam({name: "provider", value: provider, in: "path", style: "simple", explode: false, dataType: "Provider", dataFormat: undefined})}/machines/${this.configuration.encodeParam({name: "oemMachineId", value: oemMachineId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/link`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<UnlinkMachineResponse>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
